import React from 'react';
import { useAppSelector } from '../../data/store';
import { checkIsSubscription } from '../../domain/shopping-cart-provider';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import { ICartItem } from '../../interfaces';

export const getPeriodText = (period: string|undefined) => {
    if(!period) return '';

    switch(period) {
        case 'annual': {
            return 'year';
        }
        case 'monthly': {
            return 'month';
        }
        case 'weekly': {
            return 'week';
        }
        case 'daily': {
            return 'day';
        }
    }

    return '';
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-2667
 */
const ConfirmText = () => {

    const cartData = useAppSelector(store => store.root.cartData);

    const isSubscription = checkIsSubscription(cartData);
    let subscription: ICartItem| null|undefined = null;
    let text = '';

    if(isSubscription){
        subscription = cartData.cartItems.find(cartItem => cartItem.isActive) ?? null;

        const hasTax = cartData.priceData.collectTax;
        const hasCoupons = cartData.redeemedCoupons.length > 0;
        const numberOfFreeDays = Number(subscription?.numberOfFreeDays) || 0;
        const hasFreeTrial = numberOfFreeDays > 0;

        // monthly or yearly - (SP returns monthly or annual in field SBSPeriod)
        let period = (subscription?.sbsPeriod ?? 'monthly');
        if(period === 'annual'){
            period = 'annually';
        }
        period = ` ${ period }`

        if(!hasFreeTrial && !hasCoupons && !hasTax){
            // no free trial, no coupon, no tax
            text = `${period}. `;
        }

        if(!hasFreeTrial && !hasCoupons && hasTax){
            // no free trial, no coupon, tax
            text = `${ period }, not including taxes. `;
        }

        if(!hasFreeTrial && hasCoupons && !hasTax){
            // no free trial, coupon, no tax
            text = `${ period } not including the discounts above. `
        }

        if(!hasFreeTrial && hasCoupons && hasTax){
            // no free trial, coupon, tax
            text = `${ period } not including the discounts above and taxes. `;
        }

        // -----------------

        if(hasFreeTrial && !hasCoupons && !hasTax){
            // free trial, no coupon, no tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial. `;
        }

        if(hasFreeTrial && !hasCoupons && hasTax){
            // free trial, no coupon, tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial, not including taxes. `;
        }

        if(hasFreeTrial && hasCoupons && !hasTax){
            // free trial, coupon, no tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial, not including the discounts above. `
        }

        if(hasFreeTrial && hasCoupons && hasTax){
            // free trial, coupon, tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial, not including the discounts above and taxes. `;
        }
    }

    return (
        <div className="text-gray-700 mb-4 mt-10 text-sm">
            <p>
                <span>All sales are final, all prices are in US dollars. </span>

                {
                    isSubscription && subscription && (
                        <>
                            You will be charged <ProductPriceFormat price={ subscription.skU_MSRP } /> { text }
                            Your subscription will automatically renew each { getPeriodText(subscription?.sbsPeriod) } until you cancel.
                            You acknowledge that you have read and agree to the <a href="/legal/eula">End User License Agreement</a>.
                        </>
                    )
                }
            </p>
        </div>
    )
};

export default ConfirmText;